import AjaxForm, {EVENT_SUCCESS, EVENT_ERROR} from "webPage/AjaxForm";
import RecaptchaHelper from "util/RecaptchaHelper";
import {svg_include} from "index";

export default class NewsletterForm {
    constructor($element) {
        this.$element = $element;
        this.$form = this.$element.find('.js-form');
        this.enableFormJs = this.enableFormJs.bind(this);

        $(window).on('scroll', this.enableFormJs);
        this.enableFormJs();
    }

    enableFormJs() {

        let cuttoff = $('body').outerHeight() / 2;
        const scrollCutoff = $('#footer').offset().top - $(window).outerHeight();

        if (scrollCutoff < cuttoff) {
            cuttoff = scrollCutoff;
        }

        if ($(window).scrollTop() < cuttoff) {
            return;
        }

        this.bindEvents();

        $(window).off('scroll', this.enableFormJs)
    }

    bindEvents() {
        RecaptchaHelper.load().then(() => {
            RecaptchaHelper.init(this.$element);

            this.form = new AjaxForm(this.$form, async ($form, formData) => {

                const response = await RecaptchaHelper.validate().then((captcha) => {
                    formData.captcha = captcha;
                    return Ajax.post('mills-cnc', 'signup', formData);
                });

                if (response.status !== 'success') {
                    throw response;
                }

                return response;
            });

            this.form.on(EVENT_SUCCESS, (data) => {
                this.$element.addClass('signup-form--submitted');

                this.$form.html(
                    eotwJSXFactory('div', {className: "confirmation-message", id: "gf_8"}, [
                        eotwJSXFactory('div', {className: "confirmation-message__icon", unsafeHtml: svg_include('form-confirmation-icon')}),
                        eotwJSXFactory('h2', null, ["Thanks for signing up!"]),
                        eotwJSXFactory('p', null, ["Thank you for signing up to the Mills CNC newsletter, which will keep you up to date on all the latest news and events."])
                    ])
                );

                dataLayer.push({
                    'event': 'newsletter-submit',
                });
            }).on(EVENT_ERROR, (e) => {
                console.trace('error', e);
                this.$form.find('button[type="submit"]').removeClass('btn--loading');
            });
        });
    }
}